import { useSelector } from "react-redux"
import { apis } from "../api/apiUrl"


export function retrunAssets(asset) {
    return asset ? apis.base_url + asset : returnNotImage()
}

export function returnPdf(pdf) {
    return apis.domain + pdf
}

export function returnNotImage(){
    return "/assets/no_image.jpg"
}

export function GetCourseDetailPath(courseName) {

    const state = useSelector(state => state.allProgrammes)
    const colleges = state?.data?.properties?.colleges?.items

    const selectedCollege = colleges?.find(college =>
        college?.content?.properties?.courses?.find(course =>

            course?.route?.path.split('/')[3] == courseName

        )

    )
    console.log(selectedCollege,colleges)
    const course = selectedCollege?.content?.properties?.courses?.find(course =>
        course?.route?.path.split('/')[3] == courseName
    )
    return course?.route?.path


}

